import firebase from 'firebase/app'
import 'firebase/functions'

export const checkDeletedAccount = async email => {
    if (!email) return null

    try {
        const check = firebase.functions().httpsCallable('httpPayments-checkDeletedAccount')
        const res = await check({ email })
        const info = res && res.data
        return info && info.deleted ? info : null
    } catch (e) {
        return null
    }
}
